import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { MagnifyingGlass } from '@phosphor-icons/react';

const OrganizationChartFilters = ({
  filters,
  values,
  onChange,
}) => {
  const set = (key, value) => onChange({ ...values, [key]: value });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3" data-testid="org-chart-filters">
      <div className="space-y-1.5 md:col-span-2 xl:col-span-1">
        <Label className="text-xs">Search</Label>
        <div className="relative">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input
            value={values.search || ''}
            onChange={(e) => set('search', e.target.value)}
            placeholder="Name, email, or designation"
            className="pl-9"
            data-testid="org-chart-search"
          />
        </div>
      </div>

      <div className="space-y-1.5">
        <Label className="text-xs">Organization</Label>
        <Select value={values.organization || 'all'} onValueChange={(v) => set('organization', v)}>
          <SelectTrigger data-testid="org-chart-org-filter"><SelectValue placeholder="All organizations" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Organizations</SelectItem>
            {(filters.organizations || []).map((org) => (
              <SelectItem key={org} value={org}>{org}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1.5">
        <Label className="text-xs">Department</Label>
        <Select value={values.department || 'all'} onValueChange={(v) => set('department', v)}>
          <SelectTrigger data-testid="org-chart-dept-filter"><SelectValue placeholder="All departments" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Departments</SelectItem>
            {(filters.departments || []).map((dept) => (
              <SelectItem key={dept} value={dept}>{dept}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1.5">
        <Label className="text-xs">Team</Label>
        <Select value={values.team || 'all'} onValueChange={(v) => set('team', v)}>
          <SelectTrigger data-testid="org-chart-team-filter"><SelectValue placeholder="All teams" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Teams</SelectItem>
            {(filters.teams || []).map((teamName) => (
              <SelectItem key={teamName} value={teamName}>{teamName}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1.5">
        <Label className="text-xs">Location Type</Label>
        <Select value={values.locationType || 'all'} onValueChange={(v) => set('locationType', v)}>
          <SelectTrigger data-testid="org-chart-location-filter"><SelectValue placeholder="All locations" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Location Types</SelectItem>
            {(filters.locationTypes || []).map((loc) => (
              <SelectItem key={loc} value={loc}>{loc}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-1.5">
        <Label className="text-xs">Status</Label>
        <Select value={values.active || 'active'} onValueChange={(v) => set('active', v)}>
          <SelectTrigger data-testid="org-chart-active-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="active">Active Users</SelectItem>
            <SelectItem value="inactive">Inactive Users</SelectItem>
            <SelectItem value="all">All Users</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default OrganizationChartFilters;
